var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconForehead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m22.82,51.81l-12.71-4.21c-2.45-.81-3.28-3.86-1.57-5.8h0c3.19-3.62,8.23-4.99,12.81-3.48l12.71,4.21c2.45.81,3.28,3.86,1.57,5.8h0c-3.19,3.62-8.23,4.99-12.81,3.48Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m32.79,41.64l-9.76-3.23c-1.88-.62-2.52-2.96-1.21-4.45h0c2.45-2.78,6.32-3.83,9.84-2.67l9.76,3.23c1.88.62,2.52,2.96,1.21,4.45h0c-2.45,2.78-6.32,3.83-9.84,2.67Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m40.81,33.98l-8-2.65c-1.54-.51-2.06-2.43-.99-3.65h0c2.01-2.28,5.18-3.14,8.06-2.19l8,2.65c1.54.51,2.06,2.43.99,3.65h0c-2.01,2.28-5.18,3.14-8.06,2.19Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m46.7,27.41l-5.91-1.96c-1.14-.38-1.53-1.8-.73-2.7h0c1.48-1.69,3.83-2.32,5.96-1.62l5.91,1.96c1.14.38,1.53,1.8.73,2.7h0c-1.48,1.69-3.83,2.32-5.96,1.62Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.62px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m46.02,21.13h0c.58-1.75,1.89-3.15,3.59-3.86l5.26-2.18c.77-.32,1.59.31,1.48,1.14l-.2,1.54c-.25,1.93-1.37,3.63-3.04,4.63l-1.17.7-5.91-1.96Z",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.62px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForehead);
export default __webpack_public_path__ + "static/media/icon_forehead.5e0573cb.svg";
export { ForwardRef as ReactComponent };